import {SimplePresentation, SimplePresentationRunnerController} from "../../../SimplePresentationRunner";
import {XwaysHoarder2Model} from "../../../server/XwaysHoarder2Model";
import {XW2GameMode, XwaysHoarder2} from "../../../XwaysHoarder2";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {XwaysHoarder2Sound} from "../../../sound/XwaysHoarder2Sound";


export class FreespinEnd implements SimplePresentation {
    name: string = "freespinEnd";

    private fromRs: boolean = false;
    private fromFs: boolean = false;
    private fromSfS: boolean = false;
    private flowController: SimplePresentationRunnerController;

    shouldRun(): boolean {

        this.fromRs = XwaysHoarder2Model.isCurrentModeAndEnteringNormal(XwaysHoarder2.model.data, GameMode.RESPIN);
        this.fromFs = XwaysHoarder2Model.isCurrentModeAndEnteringNormal(XwaysHoarder2.model.data, GameMode.FREESPIN);
        this.fromSfS = XwaysHoarder2Model.isCurrentModeAndEnteringNormal(XwaysHoarder2.model.data, XW2GameMode.SUPER_FREESPIN);

        return ((this.fromFs || this.fromSfS) && (!XwaysHoarder2.model.data.brokeTheBank));
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline(),
            totalWin: number = XwaysHoarder2.model.gameData.accumulatedRoundWin,
            playedBet: number = XwaysHoarder2.getBuyFeaturePrice(),
            isFsBad: boolean = totalWin < playedBet;
        this.flowController = controller;
        XwaysHoarder2.foregroundElements.skipped = false;

        if (this.fromFs || this.fromSfS) {
            controller.setSkipCallback();
            XwaysHoarder2.bonusOutro.setSkipped(false);
            XwaysHoarder2.keypadPlugin.setZeroBetSpinCounter(-1);
            XwaysHoarder2.reelView.symbolsToNormalLayer();

            //make door and BG transition downwards
            tl.add(XwaysHoarder2.bonusDoors.closeGate(XwaysHoarder2.model.data.nextMode));
            tl.add(() => {
                isFsBad ? XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.FS_END_BAD) : XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.FS_END_GOOD);
                XwaysHoarder2Sound.switchMusic({name: XwaysHoarder2Sound.BONUS_OUTRO});
            }, "<");

            tl.add(XwaysHoarder2.darkOverlay.addOverlay(0.7));
            tl.addLabel("GATES_CLOSED");
            tl.add(() => {
                controller.setSkipCallback(() => {
                    XwaysHoarder2.foregroundElements.skipped = true;
                    XwaysHoarder2.bonusOutro.setSkipped();
                    XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.ELEVATOR);
                    tl.seek("POST_COUNTUP", false)});
            },"GATES_CLOSED");
            tl.add(XwaysHoarder2.waysCounter.transitionfade(0, 0.05), "<");
            tl.add(XwaysHoarder2.reelView.hideReels(),"<");
            tl.add(XwaysHoarder2.fsIndicators.hide(),"<");

            tl.add(XwaysHoarder2.bonusOutro.showBonusOutro(),"<");
            // endIntroTl.add(XwaysHoarder2.transitionPlayer.playSpineTransition(XW2GameMode.BINGE_SPINS, XW2GameMode.FREESPIN));
            // endIntroTl.add(XwaysHoarder2.transitionPlayer.playSpineTransition(XW2GameMode.BINGE_SPINS, XW2GameMode.SUPER_FREESPIN));

            if(XwaysHoarder2.model.data.currentFSLevel === 4) {
                switch(XwaysHoarder2.model.mode) {
                    case XW2GameMode.FREESPIN:
                        tl.add(XwaysHoarder2.transitionPlayer.playSpineTransition(XW2GameMode.NORMAL, XW2GameMode.FREESPIN),"<");
                        break;
                    case XW2GameMode.SUPER_FREESPIN:
                        tl.add(XwaysHoarder2.transitionPlayer.playSpineTransition(XW2GameMode.NORMAL, XW2GameMode.SUPER_FREESPIN),"<");
                        break;

                }
            }
            else {
                switch (XwaysHoarder2.model.mode) {
                    case XW2GameMode.FREESPIN:
                        tl.add(XwaysHoarder2.transitionPlayer.playSpineTransition(XW2GameMode.NORMAL, XW2GameMode.FREESPIN),"<");
                        break;
                    case XW2GameMode.SUPER_FREESPIN:
                        tl.add(XwaysHoarder2.transitionPlayer.playSpineTransition(XW2GameMode.NORMAL, XW2GameMode.SUPER_FREESPIN),"<");
                        break;
                }
            }


            tl.add(() => {
                XwaysHoarder2.transitionPlayer.playSpineIdleLoop(XwaysHoarder2.model.nextMode);
            });
            //tl.add(XwaysHoarder2.backgroundElements.setBackground(XwaysHoarder2.model.data.nextMode, this.fromFs ? GameMode.FREESPIN : this.fromSfS ? XW2GameMode.SUPER_FREESPIN : XW2GameMode.BINGE_SPINS));
            //tl.add(XwaysHoarder2.foregroundElements.setForeground(XwaysHoarder2.model.data.nextMode, this.fromFs ? GameMode.FREESPIN : this.fromSfS ? XW2GameMode.SUPER_FREESPIN : XW2GameMode.BINGE_SPINS), "<");

            tl.add(XwaysHoarder2.bonusDoors.transitionDownwardsNew());
            tl.add(XwaysHoarder2.reelView.showReels());
            tl.add(XwaysHoarder2.backgroundElements.backPlateTransition(XwaysHoarder2.model.data.nextMode));
            tl.add(XwaysHoarder2.waysCounter.transitionfade(1,0.05),"<");


            tl.addLabel("POST_COUNTUP")
            tl.add(() => {
                controller.setSkipCallback();
            });
            tl.add(XwaysHoarder2.transitionScreen.enableButton(() => this.onButtonClick(controller)));

        }
    }


    private onButtonClick(controller: SimplePresentationRunnerController) {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(XwaysHoarder2.bonusOutro.hideBonusOutro());// hide outro
        tl.add(() => {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.BONUS_OUTRO_END);
            XwaysHoarder2Sound.switchMusic({name: XwaysHoarder2Sound.MAIN_GAME_MUSIC});
        }, "<");
        tl.add(XwaysHoarder2.bonusDoors.openGate(XwaysHoarder2.model.data.nextMode));
        tl.add(() => {
          //  XwaysHoarder2.reelView.resetLockedXways();
            XwaysHoarder2.fsIndicators.resetAllIndicators();
            XwaysHoarder2.keypadPlugin.show();
            XwaysHoarder2.fsIndicators.hide();
            controller.setSkipCallback();
            controller.finish();
        });
    }


}